export const Colors = {
  Primary: '#529BD2',
  PrimaryDark: '#3B7CB0',
  MediumBlue: '#3579ba',
  LightBlue: '#e8f4fc',
  Blue: '#1858B7',
  White: '#ffffff',
  Black: '#000000',
  Grey: '#A0A0A0',
  Green: '#05831a',
  Transparent: 'transparent',
  MediumGrey: '#B4B4B4',
  LightGrey: '#F0F0F0',
  UnderlinedGrey: '#B6B0A0',
  DarkGrey: '#8D8D8D',
  GreyLine: '#D9D9D9',
  Red: '#ff0000',
  HoverGrey: '#e8e8e8',
  Beige: '#E8E3D6',
  PrimaryBackground: 'radial-gradient(52.92% 82.55% at 36.46% 41.58%, #529BD2 0%, #357ABB 59.75%)',
  IceGrey: '#F4F4F4',
  VeryDarkGrey: '#757575',
  WhiteOpacity: 'rgba(255, 255, 255, 0.6)',
  Disabled: 'rgba(0, 0, 0, 0.12)',
  Sent: '#faab01',
  Confirmed: '#05831a',
  Unavailability: '#8f8f8f',
  borderRowList: '#e0e0e0',
  Unselected: '#b2b2b2',
  BrightGreen: '#19ac55',
  SelectedDateCalendar: '#2bbb65'
};
